import context from '@truckdown/components-systems';
import { IPromotionManager } from '@truckdown/promotions';
import { defineComponent, ref, Ref } from "vue";
import { showMessage } from '../../Utilities/utilities';

interface IData {
    isLoading: Ref<boolean>,
    showError: Ref<boolean>,
    promotionId: Ref<string>
};

const getInitialData = function (props: any) {
    return {
        isLoading: ref<boolean>(false),
        showError: ref<boolean>(false),
        promotionId: ref<String>(props.promotionid)
    } as IData;
}

const getMethods = function (data: IData) {
    return {
        approvePromotionCancelClick: function (): void {
            context.events.emit(promotionUpdatedEventName + data.promotionId.value, false);
        },
        approvePromotionSaveClick: async function (): Promise<void> {
            await approvePromotion(data);
        }
    }
}

const approvePromotion = async function (data: IData): Promise<void> {
    if (!data.isLoading.value) {
        data.isLoading.value = true;
        try {
            let mgr = await context.getService<IPromotionManager>('IPromotionManager');
            var response = await mgr.enable(data.promotionId.value);
            if (!response || !response.ok) {
                showMessage("Error approving promotion", "danger", true, true);
            } else {
                showMessage("Promotion was successfully approved.", "success", true, true);
                context.events.emit(promotionUpdatedEventName + data.promotionId.value, true);
            }
        } catch (err) {
            console.log(err);
            showMessage("Error approving promotion.", "danger", true, true);
        } finally {
            data.isLoading.value = false;
        }
    }
}

const promotionUpdatedEventName = 'promotion-update';

export default defineComponent({
    props: {
        promotionid: String
    },
    emits: ["reload-promotions"],
    setup: function (props) {

        let data = getInitialData(props);
        let methods = getMethods(data);

        return {
            ...data,
            ...methods
        };
    }
});